import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Send } from 'lucide-react';
interface Message {
  id: string;
  from: 'user' | 'agent';
  text: string;
  time: string;
}
const INITIAL_MESSAGES: Message[] = [{
  id: '1',
  from: 'agent',
  text: 'Good morning, Matt. You have 3 priority emails and a meeting at 11. Want me to run through them?',
  time: '9:02 AM'
}, {
  id: '2',
  from: 'user',
  text: 'Yes, start with the emails',
  time: '9:02 AM'
}, {
  id: '3',
  from: 'agent',
  text: "**Sarah** needs Q2 budget approval. She's asking you to sign off on the revised numbers before the board meeting on Friday.\n\n**James** sent the Acme Corp contract for review. Key change is the liability clause in section 4.2.\n\n**Lisa** flagged that the server certificate expires Friday. She has a PR ready but needs your approval to deploy to prod.",
  time: '9:02 AM'
}, {
  id: '4',
  from: 'user',
  text: 'Approve Lisa\'s PR and tell Sarah I\'ll review the budget by end of day',
  time: '9:03 AM'
}, {
  id: '5',
  from: 'agent',
  text: "Done. I've approved Lisa's PR and sent Sarah a message letting her know you'll review by EOD.\n\nShall I pull up the Acme contract for your 11am meeting?",
  time: '9:03 AM'
}];
export function ChatView() {
  const [messages, setMessages] = useState(INITIAL_MESSAGES);
  const [input, setInput] = useState('');
  const handleSend = () => {
    if (!input.trim()) return;
    const userMsg: Message = {
      id: String(Date.now()),
      from: 'user',
      text: input,
      time: new Date().toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit'
      })
    };
    setMessages([...messages, userMsg]);
    setInput('');
    setTimeout(() => {
      const agentMsg: Message = {
        id: String(Date.now() + 1),
        from: 'agent',
        text: "I'll look into that for you.",
        time: new Date().toLocaleTimeString([], {
          hour: '2-digit',
          minute: '2-digit'
        })
      };
      setMessages(prev => [...prev, agentMsg]);
    }, 1000);
  };
  const renderMarkdown = (text: string) => {
    return text.split('\n').map((line, i) => {
      const bold = line.replace(/\*\*(.*?)\*\*/g, '<strong class="text-[#e8e4df]">$1</strong>');
      return <p key={i} className={i > 0 ? 'mt-2' : ''} dangerouslySetInnerHTML={{
        __html: bold
      }} data-id="element-387" />;
    });
  };
  return <div className="min-h-[calc(100vh-56px)] flex flex-col text-[#e8e4df] selection:bg-[#4a9a9a]/30" data-id="element-388">
      <div className="flex-1 overflow-y-auto px-6 py-8" data-id="element-389">
        <div className="max-w-[640px] mx-auto flex flex-col gap-4" data-id="element-390">
          {messages.map((msg, index) => <motion.div key={msg.id} initial={{
          opacity: 0,
          y: 8
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          delay: index * 0.03,
          ease: [0.23, 1, 0.32, 1]
        }} className={`flex ${msg.from === 'user' ? 'justify-end' : 'justify-start'}`} data-id="element-391">
              <div className={`max-w-[85%] rounded-[16px] px-5 py-4 ${msg.from === 'user' ? 'bg-[#252530] text-[#e8e4df]' : 'bg-[#1c1c22] text-[#e8e4df]/90'}`} data-id="element-392">
                <div className="text-[15px] leading-[1.6]" data-id="element-393">{renderMarkdown(msg.text)}</div>
                <span className="text-[11px] text-[#8a8680]/40 mt-2 block" data-id="element-394">{msg.time}</span>
              </div>
            </motion.div>)}
        </div>
      </div>

      <div className="border-t border-[#8a8680]/10 px-6 py-4" data-id="element-395">
        <div className="max-w-[640px] mx-auto flex items-center gap-3" data-id="element-396">
          <input type="text" value={input} onChange={e => setInput(e.target.value)} onKeyDown={e => e.key === 'Enter' && handleSend()} placeholder="Type a message..." className="flex-1 bg-[#1c1c22] text-[#e8e4df] rounded-[12px] px-5 py-3 text-[15px] outline-none placeholder:text-[#8a8680]/40 focus:ring-1 focus:ring-[#4a9a9a]/30" data-id="element-397" />
          <button onClick={handleSend} className="w-11 h-11 rounded-[12px] bg-[#4a9a9a] hover:bg-[#5bb5b5] flex items-center justify-center transition-colors shrink-0" data-id="element-398">
            <Send size={18} className="text-[#141418]" data-id="element-399" />
          </button>
        </div>
      </div>
    </div>;
}